<template>
    <div class="kgk-login">
        <LoginForm />

        <PasswordForgotten />

        <p v-if="inviteId">Du hast noch keinen Account? <router-link :to="`/register/${inviteId}`">Hier</router-link> geht es zur Registrierung – du trittst dem Team direkt nach der Anmeldung bei.</p>
        <p v-else>Du hast noch keinen Account? <router-link to="/register">Hier</router-link>  geht es zur Registrierung.</p>
    </div>
</template>

<script>
    // @ is an alias to /src
    import router from '../router';

    import LoginForm from '@/components/login/LoginForm.vue';
    import PasswordForgotten from '@/components/login/PasswordForgotten.vue';

    export default {
        name: 'Login',
        components: {
            LoginForm,
            PasswordForgotten,
        },
        computed: {
            inviteId() {
                return this.$route.params.inviteId;
            }
        },
        mounted() {
            if( this.$global.session.token ) {
                router.push('/runs');
            }
        }
    }
</script>
